export const DASH_RECENT_CANCELLATIONS_GRID_CONFIG_ID = 'dash-recent-cancellations'

export const DASH_RECENT_CANCELLATIONS_GRID_CONFIG = {
  id: DASH_RECENT_CANCELLATIONS_GRID_CONFIG_ID,
  layout: {
    xl: { i: DASH_RECENT_CANCELLATIONS_GRID_CONFIG_ID, x: 7.05, y: 3, w: 4.95, h: 3, static: true },
    lg: { i: DASH_RECENT_CANCELLATIONS_GRID_CONFIG_ID, x: 0, y: 6, w: 6, h: 3, static: true },
    md: { i: DASH_RECENT_CANCELLATIONS_GRID_CONFIG_ID, x: 4, y: 6, w: 8, h: 3, static: true },
    sm: { i: DASH_RECENT_CANCELLATIONS_GRID_CONFIG_ID, x: 0, y: 10.85, w: 12, h: 3, static: true },
    xs: { i: DASH_RECENT_CANCELLATIONS_GRID_CONFIG_ID, x: 0, y: 10.75, w: 12, h: 1.75, static: true },
    xxs: { i: DASH_RECENT_CANCELLATIONS_GRID_CONFIG_ID, x: 0, y: 9.95, w: 12, h: 1.75, static: true }
  }
}
